<template>
  <div class="container">
    <v-layout>
      <v-flex xs6>
        <h2>
          {{ $t('Admin/Bot Handover') }}
          <a
            href="https://tinyurl.com/ycnys8jd"
            target="blank"
            ><i style="font-size: 16px; color: #ed1e79;" class="fas fa-question-circle"></i
          ></a>
        </h2>
      </v-flex>

      <v-flex xs6 class="text-xs-right">
        <v-btn fab small outline color="primary" v-if="!isEditCommand" @click="editCommand">
          <i class="fas fa-pencil-alt"></i>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <div style="margin-top: 10px;">{{ $t('Shortcut to pause a bot') }}</div>
        <div class="form-control" :class="{ 'has-error': errors.has('changestatetoadmin') }">
          <input
            name="changestatetoadmin"
            v-validate="'required'"
            small
            v-if="isEditCommand"
            type="text"
            v-model="hotkey.changestatetoadmin"
          />
          <div v-else class="primary--text">{{ hotkey.changestatetoadmin }}</div>
          <span class="text-error" v-if="errors.has('changestatetoadmin')">{{
            errors.first('changestatetoadmin')
          }}</span>
        </div>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <div style="margin-top: 10px;">{{ $t('Shortcut to continue a bot') }}</div>
        <div class="form-control" :class="{ 'has-error': errors.has('changestatetobot') }">
          <input
            v-validate="'required'"
            name="changestatetobot"
            small
            v-if="isEditCommand"
            type="text"
            v-model="hotkey.changestatetobot"
          />
          <div v-else class="primary--text">{{ hotkey.changestatetobot }}</div>
          <span class="text-error" v-if="errors.has('changestatetobot')">{{
            errors.first('changestatetobot')
          }}</span>
        </div>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 style="text-align: center">
        <div v-if="isEditCommand">
          <v-btn @click="cancel" color="grey" :disabled="loading" outline>{{ $t('cancel') }}</v-btn>
          <v-btn @click="changeBotState" color="primary" :loading="loading" depressed>{{
            $t('Save')
          }}</v-btn>
          <!-- 
          <a @click="cancel" class="btn btn-outline-gray">{{$t('Cancel')}}</a>
          <a @click="changeBotState" class="btn">{{$t('Save')}}</a>-->
        </div>
      </v-flex>
    </v-layout>
    <div class="red--text">*** {{ $t('Only for Facebook/Instagram') }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  data() {
    return {
      hotkey: {
        changestatetoadmin: '',
        changestatetobot: ''
      },
      loading: false,
      cache: '',
      isEditCommand: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      setting: 'setting'
    })
  },
  mounted() {
    if (this.setting && this.setting.change_state_to_admin) {
      this.hotkey.changestatetoadmin = this.setting.change_state_to_admin.contentvalue
    }
    if (this.setting && this.setting.change_state_to_bot) {
      this.hotkey.changestatetobot = this.setting.change_state_to_bot.contentvalue
    }
  },
  methods: {
    cancel() {
      this.isEditCommand = false
      this.hotkey = JSON.parse(this.cache)
    },
    editCommand() {
      this.isEditCommand = true
      this.cache = JSON.stringify(this.hotkey)
    },
    changeBotState(type) {
      let vm = this
      this.loading = true
      let obj = {
        pageid: this.selectedBot.pageid,
        input: {
          changestatetoadmin: this.hotkey.changestatetoadmin,
          changestatetobot: this.hotkey.changestatetobot
        }
      }

      api.putchangebotstate(obj, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.isEditCommand = false
        vm.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/adminHandOver.vue